function add_cs_product(e) {
	var checkbox = e.currentTarget;
	var label = checkbox.parentElement;

	var fieldsets = document.querySelectorAll('.add-to-cart-form .cs_fieldset');

	if (checkbox.checked) {
		label.classList.add('checked');

		fieldsets.forEach( function(x) {
			var input = document.createElement('input');

			input.type = 'hidden';
			input.name = 'id[]';
			input.value = checkbox.value;

			x.appendChild(input);
		} );
	}

	else {
		label.classList.remove('checked');

		fieldsets.forEach( function(x) {
			var input = x.querySelector( 'input[value = "' + checkbox.value + '"]' );

			if (input) input.remove();
		} );
	}
}


document.querySelectorAll('#cross_selling img').forEach( function(x) {
	x.addEventListener('click', function(e) {
		var container = e.currentTarget.closest('.scrollable_item');
		var checkbox = container.querySelector('.checkbox-round input');

		checkbox.checked = !checkbox.checked;
		checkbox.dispatchEvent( new Event('change') );
	} );
} );

document.querySelectorAll('#cross_selling .checkbox-round input').forEach( function(x) {
	x.addEventListener('change', add_cs_product);
} );